export const tr = {
    'image-preview-header': 'Görsel önizlemesi',
    'image-preview-header-with-name': '"{name}" görselinin önizlemesi',
    'selected-categories-count': {
        one: '{count} konu seçildi',
        some: '{count} konu seçildi',
        many: '{count} konu seçildi',
        none: 'Konu seç'
    },
    title: 'Görsel galerisi'
};
